import React from 'react';

export default function Hero() {
  return (
    <section id="inizio" className="relative pt-16 pb-28 md:py-36 overflow-hidden">
      <div className="hero-blob hero-blob-1" />
      <div className="hero-blob hero-blob-2" />

      <div
        className="absolute inset-x-0 top-0 h-full pointer-events-none flex items-start justify-center opacity-[0.035] select-none"
        data-parallax="0.18"
        style={{ transform: 'translateY(var(--py, 0))' }}
        aria-hidden
      >
        <span className="font-serif text-[22vw] leading-none text-forestDark tracking-tighter -mt-10">ψ</span>
      </div>

      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-7 space-y-8 z-10">
          <div className="hero-anim inline-flex items-center space-x-2 bg-sageLight/50 text-forestDark px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider" style={{ ['--d' as any]: '0ms' }}>
            <span>Consulenza Psicologica Online — Primo colloquio gratuito</span>
          </div>

          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-forestDark leading-[1.05] tracking-tight">
            <span className="hero-anim inline-block" style={{ ['--d' as any]: '80ms' }}>C'è una parte di te</span> <br />
            <span className="hero-anim inline-block" style={{ ['--d' as any]: '180ms' }}>che osserva</span>{' '}
            <span className="hero-anim italic font-light text-sage inline-block" style={{ ['--d' as any]: '280ms' }}>in silenzio.</span>
          </h1>

          <p className="hero-anim text-lg text-charcoal/80 leading-relaxed max-w-xl" style={{ ['--d' as any]: '380ms' }}>
            Conosce i tuoi sogni, i tuoi timori, le tue ferite più antiche. È l'inconscio, ed è lì che inizia il vero cambiamento. Sono il Dr. Michele Balducci, psicologo e psicoterapeuta: integro la prospettiva junghiana con l'ipnosi ericksoniana per aiutarti a ritrovare il centro.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
            <div className="hero-anim flex items-start space-x-3" style={{ ['--d' as any]: '480ms' }}>
              <span className="text-forest mt-1">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
              </span>
              <div>
                <h4 className="font-semibold text-forestDark">Spazio privato e accogliente</h4>
                <p className="text-xs text-charcoal/70">Ascolto profondo, senza giudizio, nel pieno rispetto del segreto professionale.</p>
              </div>
            </div>
            <div className="hero-anim flex items-start space-x-3" style={{ ['--d' as any]: '580ms' }}>
              <span className="text-forest mt-1">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
              </span>
              <div>
                <h4 className="font-semibold text-forestDark">Online su Google Meet</h4>
                <p className="text-xs text-charcoal/70">Sedute di 45 minuti, ovunque tu sia, in totale riservatezza.</p>
              </div>
            </div>
          </div>

          <div className="hero-anim flex flex-col sm:flex-row items-center gap-4 pt-6" style={{ ['--d' as any]: '680ms' }}>
            <a href="#prenota" className="btn-shine w-full sm:w-auto text-center bg-forest hover:bg-forestDark text-cream px-8 py-4 rounded-full font-medium text-base shadow-lg hover:shadow-xl smooth-transition hover:-translate-y-0.5">
              Prenota il primo colloquio
            </a>
            <a href="#approccio" className="w-full sm:w-auto text-center border border-forest/20 hover:border-forest/50 text-forestDark px-8 py-4 rounded-full font-medium text-base smooth-transition hover:-translate-y-0.5">
              Scopri il mio approccio
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 relative flex justify-center">
          <div className="hero-anim relative w-full max-w-sm md:max-w-md" style={{ ['--d' as any]: '300ms' }}>
            <div className="absolute -inset-4 bg-sage/10 rounded-3xl transform rotate-2 animate-tilt" />
            <div className="absolute -top-6 -left-6 w-16 h-16 bg-sageLight rounded-full mix-blend-multiply filter blur-lg opacity-80 animate-float-slow" />
            <div
              className="absolute -bottom-10 -right-8 w-24 h-24 bg-clay/20 rounded-full mix-blend-multiply filter blur-2xl"
              data-parallax="-0.08"
              style={{ transform: 'translateY(var(--py, 0))' }}
            />

            <div className="card-3d relative bg-cream p-4 rounded-3xl shadow-xl border border-forest/5 overflow-hidden">
              <div className="aspect-[4/5] bg-sageLight/75 rounded-2xl flex flex-col justify-between p-6 overflow-hidden relative">
                <div className="absolute inset-0 flex items-center justify-center opacity-[0.08]">
                  <svg className="w-72 h-72 text-forest animate-spin-slowest" viewBox="0 0 200 200" fill="none" stroke="currentColor" strokeWidth="0.4">
                    <circle cx="100" cy="100" r="90" />
                    <circle cx="100" cy="100" r="70" />
                    <circle cx="100" cy="100" r="50" />
                    <circle cx="100" cy="100" r="30" />
                    <path d="M10 100 H190 M100 10 V190" />
                    <path d="M30 30 L170 170 M170 30 L30 170" />
                  </svg>
                </div>
                <div className="text-xs uppercase tracking-[0.25em] text-forest font-semibold relative">Dr. Michele Balducci</div>

                <div className="my-auto flex flex-col items-center text-center space-y-5 relative">
                  <div className="w-20 h-20 rounded-full border border-forest/20 flex items-center justify-center bg-cream shadow-inner animate-breathe">
                    <img
                      src={`${process.env.PUBLIC_URL}/logo-mark.webp`}
                      alt="Logo Dr. Michele Balducci"
                      width={343}
                      height={295}
                      className="w-12 h-auto"
                    />
                  </div>
                  <p className="font-serif text-xl italic text-forestDark px-4 leading-snug">"Ogni percorso è unico: insieme diamo voce a ciò che chiede di essere compreso."</p>
                </div>

                <div className="flex justify-between items-end text-[10px] tracking-[0.18em] text-charcoal/60 relative uppercase">
                  <span>Psicoterapia Analitica</span>
                  <span>Ipnosi Ericksoniana</span>
                </div>
              </div>

              <div className="mt-4 pt-3 border-t border-forest/10 flex justify-between items-center text-xs text-charcoal/70">
                <span>Ordine Psicologi Lazio n. 21747</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-20 md:mt-28 relative">
        <div className="reveal flex flex-wrap items-center justify-between gap-y-6 gap-x-10 border-t border-forest/10 pt-8 text-[11px] uppercase tracking-[0.25em] text-charcoal/55">
          <span>Sapienza · Roma</span>
          <span>A.I.P.A.</span>
          <span>I.A.A.P.</span>
          <span>S.I.I.P.E.</span>
          <span>Neuroscienze Cognitive</span>
        </div>
      </div>
    </section>
  );
}
